// extracted by mini-css-extract-plugin
export default {"knowledge-table":"KnowledgeBase_knowledge-table__WPA4E","header":"KnowledgeBase_header__xHpQj"};